import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AllegatoBase64Model, Environment, IRemoveFileAllegatoModel, IsErrorValues } from '../../models/-index';

@Injectable()
export class UploadService {
  // private h = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  private base: string;
  constructor(private http: HttpClient, @Inject('ENV') env: Environment) {
    this.base = env.apiUrl + '/api/Upload/';
  }
  // usata per image cropper
  SaveBase64_AsAttachmentFile(img: AllegatoBase64Model, azbase: number = 0): Observable<IsErrorValues> {
    const u = this.base + 'SaveBase64_AsAttachmentFile?azbase=' + azbase;
    return this.http.post<IsErrorValues>(`${u}`, img);
  }
  SaveBase64_AsApplicationFile(img: AllegatoBase64Model, azbase: number = 0): Observable<IsErrorValues> {
    const u = this.base + 'SaveBase64_AsApplicationFile?azbase=' + azbase;
    return this.http.post<IsErrorValues>(`${u}`, img);
  }
  RemoveFileAllegato(model: IRemoveFileAllegatoModel) {
    const u = this.base + 'RemoveFileAllegato';
    return this.http.post(`${u}`, model);
  }

  /*
  // metodo generico non usato
  public upload(files: Set<File>): { [key: string]: Observable<number> } {
    // this will be the our resulting map
    const status = {};

    files.forEach((file) => {
      // create a new multipart-form for every file
      const formData: FormData = new FormData();
      const _name = fnSanitizeFilename(file.name);
      formData.append('files', file, _name);

      // create a http-post request and pass the form
      // tell it to report the upload progress
      const url = this.base + '/ngUploadLocal';
      //  .log(url);
      const req = new HttpRequest('POST', url, formData, {
        reportProgress: true,
      });

      // create a new progress-subject for every file
      const progress = new Subject<number>();

      // send the http-request and subscribe for progress-updates

      const startTime = new Date().getTime();
      this.http.request(req).subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          // calculate the progress percentage

          const percentDone = Math.round((100 * event.loaded) / event.total);
          // pass the percentage into the progress-stream
          progress.next(percentDone);
        } else if (event instanceof HttpResponse) {
          // Close the progress-stream if we get an answer form the API
          // The upload is complete
          progress.complete();
        }
      });

      // Save every progress-observable in a map of all observables
      status[file.name] = {
        progress: progress.asObservable(),
      };
    });

    // return the map of progress.observables
    return status;
  }

  // metodo per file locali passare il percorso
  public UploadSingle_LocalFile(file: File, path: string, new_name: string = null): Observable<IsError> {
    // create a new multipart-form for every file
    const epath = btoa(path);
    const formData: FormData = new FormData();
    const _name = fnSanitizeFilename(file.name);
    formData.append('file', file, _name);
    // create a http-post request and pass the form
    // tell it to report the upload progress
    const url = `${this.base}/UploadSingle_LocalFile?epath=${epath}&new_name=${new_name}`;
    return this.http.post<IsError>(`${url}`, formData);
  }
  // metodo per file singolo certificati
  public Upload_Certificates(file: File, id: number): Observable<IsError> {
    // create a new multipart-form for every file
    const formData: FormData = new FormData();
    const _name = fnSanitizeFilename(file.name);
    formData.append('file', file, _name);
    // create a http-post request and pass the form
    // tell it to report the upload progress
    const url = this.base + '/Upload_Certificates?id=' + id;
    return this.http.post<IsError>(`${url}`, formData);
  }

  // cancella certificati

  public Delete_AttachedFile_Certificates(encoded_path: string, id: number): Observable<any> {
    const url = this.base + '/Delete_Certificates_AttachedFile?path=' + encoded_path + '&id=' + id;
    return this.http.delete(`${url}`);
  }*/
}
